export default "__VITE_ASSET__XUAOsu7U__"